module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-64.55ad84cd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-bonuses-64.png
// module id = 3187
// module chunks = 11